import 'css/common.scss';
import 'css/reset.scss';
import 'css/rtl.scss';
import { LAUNCHER_POSITION, LAUNCHER_POSITION_CSS } from './app.model';
import './app.scss';

export const AppTemplate = (model) => {
	const { position } = model;
	/* html */
	const popover = `
		<div class="engt-popover-overlay" id="engtPopoverOverlay">
			<div class="engt-popover" id="engtPopover"></div>
		</div>
	`;

	// /*html*/
	// const overlay = `
	// 	<div class="engt-media-preview engt-media-controls-wrapper engt-open-preview engt-hidden"
	// 	id="engtMediaOverlay" tabindex="0">
	// 	</div>
	// `;

	/* html */
	const html = `
		<div class="engt-wrapper ${
			position === LAUNCHER_POSITION.RIGHT
				? LAUNCHER_POSITION_CSS[LAUNCHER_POSITION.RIGHT]
				: LAUNCHER_POSITION_CSS[LAUNCHER_POSITION.LEFT]
		}" id="engtWrapper">
			<engagement-triggers></engagement-triggers>
        	<pop-up></pop-up>
			<launcher-icon></launcher-icon>
			${popover}
		</div>
	`;

	return html;
};
